import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      © 2025.Dedinged By Milad Amiri(miladamiri87@gmail.com) All Rights Reserved.
    </footer>
  );
}

export default Footer;
